<template>
  <div class="container">
      <div class="left">
        <img :src="systemInfo.front.background || bgImage" alt="" />
        <a
          v-if="systemInfo.front?.showRecordNumber"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noopener noreferrer"
          class="records"
        >
          备案：{{ systemInfo.front?.recordNumber }}
        </a>
      </div>
      <div class="right">
        <Right
          :logo="systemInfo?.front?.logo"
        />
      </div>
      <div>
        
      </div>
    </div>
</template>

<script>
import { front } from "@/api/system";

import Right from "./right.vue";

export default {
  name: "Login",
  components: {Right},
  data() {
    return {
      showPassword: false,
      systemInfo: {
        front: {}
      },
      bgImage: "/images/login/login.png"
    };
  },
  methods: {

  },
  mounted() {
    front().then(res => {
        this.systemInfo.front = res.data.result
    })
  },
};
</script>


<style scoped>
.login-form {
  background: white;
  padding: 30px 25px;
  border-radius: 8px;
  width: 320px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.login-form h2 {
  text-align: center;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 16px;
  position: relative;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.password-group input {
  padding-right: 40px;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
}

.captcha-group {
  display: flex;
  align-items: center;
}

.captcha-group input {
  flex: 1;
}

.captcha-group img {
  margin-left: 10px;
  height: 32px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-group {
  font-size: 14px;
  color: #666;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #409eff;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #66b1ff;
}

.container {
  display: flex;
  height: 100vh;
  background-color: #fff;
}

.container > div {
  height: 100%;
}

.left {
  flex: 1;
}
.left > img {
  display: block;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.records {
  position: absolute;
  top: 96%;
  left: 35%;
  color: rgba(0, 0, 0, 0.35);
  font-size: 14px;
}

.right {
  min-width: 400px;
  width: 27%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 700px) {
  .left { display: none; }
  .right { width: 100%; min-width: 0; }
}


</style>
